import { render } from "./TabsPage.vue?vue&type=template&id=308b5b24&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=308b5b24&scoped=true&lang=css"

import exportComponent from "/home/administrator/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308b5b24"]])

export default __exports__